import axios from "@helpers/axios/private.axios";

const USER_STATISTICS = {
  GET_TODAY_STATISTICS_REQUEST: "GET_TODAY_STATISTICS_REQUEST",
  GET_TODAY_STATISTICS_SUCCESS: "GET_TODAY_STATISTICS_SUCCESS",
  GET_TODAY_STATISTICS_FAILURE: "GET_TODAY_STATISTICS_FAILURE",
};

export const getTodayStatistics = () => async (dispatch) => {
  dispatch({
    type: USER_STATISTICS.GET_TODAY_STATISTICS_REQUEST,
  });

  try {
    const response = await axios.get("/users/statistics/today");

    dispatch({
      type: USER_STATISTICS.GET_TODAY_STATISTICS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: USER_STATISTICS.GET_TODAY_STATISTICS_FAILURE,
      payload: error,
    });

    console.error("Error fetching user statistics:", error);
  }
};